import { render, staticRenderFns } from "./android-url.vue?vue&type=template&id=0050473f"
import script from "./android-url.vue?vue&type=script&lang=js"
export * from "./android-url.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports